/*
 * @Descripttion:
 * @Author: wyx
 * @Date: 2020-09-09 14:56:57
 * @LastEditors: wyx
 * @LastEditTime: 2020-09-25 11:01:07
 */
import { mapGetters, mapMutations } from 'vuex'
import NoticePopover from './components/notice-popover'
import UserPopover from './components/user-popover'
import TopHeaderSearch from './components/top-header-search'
import ytBrand from '@/assets/images/user/logo@2x.png'
import servicePic from '@/assets/images/kefu.png'
import Auth from '@/utils/Auth'

export default {
    name: 'Navbar',

    components: {
        TopHeaderSearch,
        NoticePopover,
        UserPopover
    },

    data() {
        return {
            showUserInfo: false
        }
    },

    computed: {
        ...mapGetters('common', [
            'userInfo'
        ]),
        ...mapGetters('notice', [
            'noticeNum'
        ])
    },
    mounted() {
        // console.log('444444444', this.userInfo)
    },
    methods: {
        ...mapMutations('common', ['updateAuthDialogType']),
        goIndex() {
            this.$router.push({
                path: '/home'
            })
        }
    },
    render() {
        return (
            <div class='navbar'>
                <div class='navbar-brand fl' onClick={this.goIndex}>
                    <img src={ytBrand} alt='云图洞察' />
                </div>
                <div class='navbar-main'>
                    <div class='yt-search'>
                        <TopHeaderSearch />
                    </div>
                    <div class='right-tool'>
                        {/* {
                            !Auth.isLogin() && (
                                <div>
                                    <span class='nav-btn' onClick={() => this.updateAuthDialogType('login')}>登录</span>
                                    <span class='slash'>/</span>
                                    <span class='nav-btn mr__m' onClick={() => this.updateAuthDialogType('register')}>注册</span>
                                </div>
                            )
                        } */}
                        <div class='contact-service'>
                            <el-popover
                                placement='bottom'
                                trigger='hover'
                            >
                                <div class='img-wrap'>
                                    <el-image src={servicePic} style='width: 170px; height: 170px' />
                                </div>
                                <div slot='reference'>
                                    <i class='iconfont iconkefu' />
                                    联系客服
                                </div>
                            </el-popover>
                        </div>
                        <div class='message'>
                            <notice-popover>
                                {
                                    this.noticeNum === 0 && <el-button type='text' icon='el-icon-bell' slot='reference' />
                                }

                                {
                                    this.noticeNum > 0 && (
                                        <el-badge value={this.noticeNum} slot='reference'>
                                            <el-button type='text' icon='el-icon-bell' />
                                        </el-badge>
                                    )
                                }
                            </notice-popover>
                        </div>
                        <div class='user'>
                            {
                                Auth.isLogin() && (
                                    <user-popover v-model={this.showUserInfo}>
                                        <span class='username' slot='reference'>
                                            您好，{(this.userInfo.aInfoData && this.userInfo.aInfoData.sUserName) || '用户'}
                                            <i class={`${this.showUserInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'}`} />
                                        </span>
                                    </user-popover>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
